import {remCalc} from '../_utils'

const overrides = {
    Modal: {
        baseStyle: {
            checkIconBox: {
                color: 'icons.background.secondary',
            },
        },
    },
    Accordion: {
        baseStyle: {
            checkIconBox: {
                color: 'icons.background.secondary',
            },
        },
    },
    ProductDocumentation: {
        baseStyle: {
            tipIcon: {
                color: 'icons.background.secondary',
            },
        },
    },
    LoadingSpinner: {
        baseStyle: {
            spinner: {
                emptyColor: 'background.danger',
                color: 'background.red',
            },
        },
    },
    ListMenu: {
        baseStyle: {
            exploreAllButton: {
                color: 'text.default',
                fontWeight: 'normal',
            },
            filterHeaderText: {
                color: 'text.default',
            },
            subCategoryHeaderText: {
                color: 'text.default',
            },
            tertiaryLink: {
                color: 'text.default',
                fontWeight: 'normal',
            },
            subCategoryHeaderLink: {
                fontWeight: {base: 'normal', lg: 'bold'},
            },
            listMenuTriggerContainer: {
                color: 'text.default',
            },
            listMenuTriggerLink: {
                _hover: {
                    top: remCalc(-1),
                },
            },
            listMenuTriggerLinkActive: {
                top: remCalc(-1),
            },
        },
    },
    ListMenuCard: {
        variants: {
            default: {
                title: {
                    fontWeight: 'normal',
                    color: 'text.default',
                },
            },
            secondary: {
                title: {fontWeight: 'normal'},
            },
        },
    },
    DrawerMenu: {
        baseStyle: {
            secondLevelExploreAll: {
                fontWeight: '800',
            },
        },
    },
    InformativeLabel: {
        variants: {
            light: {color: 'label.text.primary'},
        },
    },
    PreFooter: {
        baseStyle: {
            newsletterText: {
                color: 'text.default',
            },
            newsletterHeader: {
                color: 'text.default',
            },
        },
    },
    LinksList: {
        baseStyle: {
            list: {
                opacity: 1,
            },
            heading: {
                color: 'text.inverse',
            },
        },
    },
    Disclaimer: {
        baseStyle: {
            heading: {
                textStyle: 'body-medium',
                fontWeight: 'bold',
            },
            bodycopy: {
                textStyle: 'body-medium',
            },
            anchor: {
                textStyle: 'body-xsmall',
                color: 'text.primary',
            },
        },
    },
    PlpBannerPromo: {
        baseStyle: {
            image: {
                borderRadius: remCalc(4),
            },
        },
    },
    PageHeader: {
        baseStyle: {
            title: {
                color: '#1A1D1F',
            },
        },
    },
    ShopTheLook: {
        baseStyle: {
            productsContainer: {
                alignSelf: 'center',
            },
        },
    },
    Faq: {
        baseStyle: {
            searchAndTitleStyles: {
                errorMessage: {
                    color: 'text.primary',
                },
            },
        },
    },
    Login: {
        baseStyle: {
            '.gigya-forgotPassword': {
                color: 'text.primary',
            },
            '.dlg-gigya-link': {
                color: 'text.primary',
            },
        },
    },
    Stories: {
        baseStyle: {
            startcta: {
                background: 'colors.null',
            },
            endcta: {
                background: 'colors.null',
            },
        },
    },
    Orders: {
        baseStyle: {
            orderNumberHeader: {
                textStyle: {base: 'head-large', lg: 'head-medium'},
            },
            multiShipmentContainer: {
                gap: {base: remCalc(24), lg: remCalc(28)},
            },
            orderDetailsNonReturnableItemsContainer: {
                px: {base: 0, lg: remCalc(24)},
            },
            orderDetailsReturnContainer: {
                px: {base: 0, lg: remCalc(24)},
            },
        },
    },
    SwatchGroup: {
        baseStyle: {
            swatchGroup: {
                textStyle: 'body-small',
            },
            swatchLabel: {
                alignItems: 'baseline',
            },
        },
    },
    ContactUs: {
        baseStyle: {
            confirmIcon: {
                color: 'text.default',
                backgroundColor: 'background.default',
            },
        },
    },
}

export default {
    components: overrides,
}
